import { render, staticRenderFns } from "./SocialMeetingPostDetailPage.vue?vue&type=template&id=1928574c&scoped=true"
import script from "./SocialMeetingPostDetailPage.vue?vue&type=script&lang=js"
export * from "./SocialMeetingPostDetailPage.vue?vue&type=script&lang=js"
import style0 from "./SocialMeetingPostDetailPage.vue?vue&type=style&index=0&id=1928574c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928574c",
  null
  
)

export default component.exports